import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import axios from "axios";
import Button from "../components/ResubleComp/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";

//=============expert signup======================
const Expertsignup = (props) => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  let navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [isDomainExpert, setisDomainExpert] = useState(false);
  const [google, setGoogle] = useState("");
  const [errorMessage, setErrormessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoaded, setisLoaded] = useState(false);

  //state to show password and confirm passwrod
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  //conditional rendering to show otp verification section
  const [needOtpVerification, setNeedOtpVerification] = useState(false);
  const [enteredOtpForVerification, setEnteredOtpForVerification] =
    useState("");
  const [otpError, setOtpError] = useState(""); // Error message for OTP verification

  //error messages for input fileds
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const submitHandler = async (e) => {
    e.preventDefault();
    const expertData = {
      name,
      email,
      password,
      confirmPassword,
      isDomainExpert: true,
    };
    setLoading(true);

    //handling error messages for name email and password
    let hasError = false;
    if (name === "") {
      setNameError("Name field is required");
      hasError = true;
    } else {
      setNameError(""); // Clear the error message
    }

    if (email === "") {
      setEmailError("E-Mail is a required field");
      hasError = true;
    } else {
      setEmailError(""); // Clear the error message
    }

    if (password === "") {
      setPasswordError("password is a required field");
      hasError = true;
    } else {
      setPasswordError(""); // Clear the error message
    }

    if (confirmPassword === "") {
      setConfirmPasswordError("Confirm Password is a require field");
      hasError = true;
    } else {
      setConfirmPasswordError(""); // Clear the error message
    }

    if (password !== confirmPassword) {
      setPasswordError("Passwords do not match");
      hasError = true;
    } else if (password === "" && confirmPassword === "") {
      setPasswordError("Password is required");
      setConfirmPasswordError("Confirm Password is required");
      hasError = true;
    } else {
      setPasswordError(""); // Clear the password error message
    }

    if (hasError) {
      setLoading(false);
      return; // Don't proceed if there are errors
    }
    const url = baseUrl + "/api/expert/register";
    const data = await fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(expertData),
    });

    if (data.status === 201) {
      var otpResponse = await data.json();
      localStorage.setItem("OtpResponseUserId", otpResponse.data.expertId);

      // Display the OTP verification section
      setNeedOtpVerification(true);
      setLoading(false);
    } else if (data.status === 400) {
      const errorResponse = await data.json();

      toast.error(errorResponse.error.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000, 
      });
    }
  };

  //verify otp functions
  const verifyOtp = async () => {
    const otpVerificationData = {
      userId: localStorage.getItem("OtpResponseUserId"),
      otp: enteredOtpForVerification,
    };
    try {
      const response = await fetch(baseUrl + "/api/expert/verify-otp", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(otpVerificationData),
      });
      const data = await response.json();

      if (response.status === 200 && data.status === true) {
        // Redirect to domainExpertDashboard upon successful OTP verification
        navigate("/problemsolver/login");
      } else {
        setOtpError(
          data.message || "OTP verification failed. Please try again."
        );
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpError("An error occurred while verifying OTP. Please try again.");
    }
  };

  const checkUserExisting = async (userDetail, id_token) => {
    setisLoaded(true);
    const URL = baseUrl + `/api/expert/google?id_token=${id_token}`; //queryparams =>id_token
    const response = await axios.post(URL, userDetail, {
      headers: {
        "Content-type": "application/json",
      },
    });
    if (response.status === 200) {
      localStorage.setItem("TOKEN", response?.data?.existingUser?.token);
      localStorage.setItem("userId", response?.data?.existingUser?._id);
      localStorage.setItem(
        "userINfo",
        JSON.stringify(response.data.existingUser)
      );
      navigate("/Next2LoginPageexpert");
      setisLoaded(false);
    } else if (response.status === 201) {
      localStorage.setItem("TOKEN", response?.data.user.existingUser?.token);
      localStorage.setItem("userId", response?.data.user.existingUser?._id);
      localStorage.setItem(
        "userINfo",
        JSON.stringify(response.data.user.existingUser)
      );
      navigate("/");
      setisLoaded(false);
    }
  };

  const firebaseConfig = {
    apiKey: "AIzaSyCPCH-BQL99kpu5DLgiB98PUR5-6IUoN7E",
    authDomain: "fynii-37e06.firebaseapp.com",
    projectId: "fynii-37e06",
    storageBucket: "fynii-37e06.appspot.com",
    messagingSenderId: "399892740732",
    appId: "1:399892740732:web:bf8bbf6f338da41f26a7f9",
    measurementId: "G-QSVT0N891D",
  };
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const provider = new GoogleAuthProvider();

  // const GoogleAuth = () => {
  //   setisLoaded(true);
  //   signInWithPopup(auth, provider).then((result) => {
  //     setGoogle(result);
  //     setisLoaded(false);
  //     const usercresd = {
  //       email: result.user.email,
  //       uid: result.user.uid,
  //       displayName: result.user.displayName,
  //       photoURL: result.user.photoURL,
  //     };
  //     const id_token = result._tokenResponse.idToken;
  //     checkUserExisting(usercresd, id_token);
  //   });
  // };

  const GoogleAuth = () => {
    window.open(`${baseUrl}/auth/google/callback`, "_self");
  };
  return (
    <div className="">
      {needOtpVerification ? (
        // <div className="flex flex-col md:flex-row rounded-lg shadow-md overflow-hidden bg-white mx-auto max-w-4xl px-4 lg:px-8 py-5 mb-5 w-1/4">
        <div className="bg-gray-100 h-screen rounded-lg flex justify-center items-center">
          <div className="w-full bg-white p-5 rounded-lg lg:w-1/4">
            <p className="text-xl font-semibold text-center">
              A 6 digit OTP has been sent to your E-mail Id. OTP will expire in
              6 mins.
            </p>
            <div className="flex flex-col mb-4 mt-5">
              <div className="w-full px-2 mb-4 md:mb-0">
                <label
                  className="block text-gray-700 text-xs font-bold mb-2 mt-1"
                  htmlFor="otp"
                >
                  Enter OTP sent to your E-mail Id
                </label>
                <input
                  type="text"
                  id="otp"
                  value={enteredOtpForVerification}
                  placeholder="Enter 6 digit OTP "
                  onChange={(e) => setEnteredOtpForVerification(e.target.value)}
                  className="appearance-none block w-full bg-white text-gray-700 border border-gray-400 rounded py-3 px-4 leading-tight focus:outline-cyan-400"
                />
                {otpError && (
                  <p className="text-red-500 text-xs mt-1">{otpError}</p>
                )}
                <div className="w-full mt-6">
                  <button
                    onClick={verifyOtp}
                    className="bg-[#338582]  w-full font-semibold rounded flex justify-center items-center text-white py-3 "
                  >
                    Verify OTP
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="h-screen bg-gray-100 lg:flex lg:justify-center lg:items-center">
          <div
            id="SignuupForm"
            className="m-5 p-5 lg:p-5  rounded-lg bg-white lg:w-1/4 lg:flex mx-auto"
          >
            <div className="w-full">
              <p className="font-josefin-sans font-bold text-xl text-center">
                Register as an Expert
              </p>

              <div className="flex flex-col -mx-2 mb-4 mt-5">
                <div className="w-full ">
                  <label
                    className="block text-gray-700 text-xs font-bold mb-2"
                    htmlFor="name"
                  >
                    Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    className="appearance-none block w-full bg-white text-gray-700 border border-gray-400 rounded py-3 px-4 leading-tight focus:outline-cyan-400"
                    id="name"
                    type="text"
                    placeholder="Write your full name"
                    value={name}
                    required
                    onChange={(e) => setName(e.target.value)}
                  />

                  {nameError && (
                    <p className="text-red-500 text-xs mt-1">{nameError}</p>
                  )}
                </div>

                <div className="w-full">
                  <label
                    className="block text-gray-700 text-xs font-bold mb-2 mt-1"
                    htmlFor="email"
                  >
                    E-mail <span className="text-red-600">*</span>
                  </label>
                  <input
                    className="appearance-none block w-full bg-white text-gray-700 border border-gray-400 rounded py-3 px-4 leading-tight focus:outline-cyan-400"
                    id="email"
                    type="email"
                    placeholder="Your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {emailError && (
                    <p className="text-red-500 text-xs mt-1">{emailError}</p>
                  )}
                </div>

                <div className="w-full mb-4 md:mb-0 relative">
                  <label
                    className="block text-gray-700 text-xs font-bold mb-2 mt-1"
                    htmlFor="password"
                  >
                    Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    className="appearance-none block w-full bg-white text-gray-700 border border-gray-400 rounded py-3 px-4 leading-tight focus:outline-cyan-400"
                    id="password"
                    placeholder="Your password"
                    value={password}
                    required
                    onChange={(e) => setPassword(e.target.value)}
                    type={showPassword ? "text" : "password"}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute top-1/2 right-5 cursor-pointer"
                  >
                    {showPassword ? (
                      <FontAwesomeIcon icon={faEyeSlash} />
                    ) : (
                      <FontAwesomeIcon icon={faEye} />
                    )}
                  </span>
                  {passwordError && (
                    <p className="text-red-500 text-xs mt-1">{passwordError}</p>
                  )}
                </div>
                <div className="w-full mb-4 md:mb-0 relative">
                  <label
                    className="block text-gray-700 text-xs font-bold mb-2 mt-1"
                    htmlFor="password"
                  >
                    Confirm Password <span className="text-red-500">*</span>
                  </label>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="appearance-none block w-full bg-white text-gray-700 border border-gray-400 rounded py-3 px-4 leading-tight focus:outline-cyan-400"
                    id="password"
                    placeholder="Your password"
                    value={confirmPassword}
                    onChange={(e) => setconfirmPassword(e.target.value)}
                  />
                  <span
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className="absolute top-1/2 right-5 cursor-pointer"
                  >
                    {showConfirmPassword ? (
                      <FontAwesomeIcon icon={faEyeSlash} />
                    ) : (
                      <FontAwesomeIcon icon={faEye} />
                    )}
                  </span>
                  {confirmPasswordError && (
                    <p className="text-red-500 text-xs mt-1">
                      {confirmPasswordError}
                    </p>
                  )}
                </div>

                <div className="w-full mt-5">
                  <Button
                    onClick={submitHandler}
                    className="bg-blue-400 w-full font-semibold rounded flex justify-center items-center text-gray-900 py-3 "
                  >
                    Sign up
                  </Button>
                </div>

                <div className="text-center">or</div>
                <div className="w-full" onClick={GoogleAuth}>
                  <button
                    id="googlebutton"
                    className="bg-white px-3 font-semibold w-full rounded flex justify-center items-center text-gray-700 py-3 border border-gray-400 "
                    onClick={GoogleAuth}
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                      className="rounded-full bg-gray-100 w-5 mx-2 hover:bg-gray-200"
                      alt=""
                    />
                    Continue with Google
                  </button>
                </div>
              </div>

              <div className="w-full mt-4">
                <p className="text-center text-gray-600">
                  Already registered?{" "}
                  <span className="text-blue-500 cursor-pointer underline">
                    <a href="/problemsolver/login"> Log in</a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Expertsignup;
